/* =========================================================
   TORVITAN — Interacciones
   ========================================================= */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Header con scroll ---------- */
  var header = $('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Buscador y menú móvil ---------- */
  $$('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var bar = $('.search-bar');
      if (!bar) return;
      bar.classList.toggle('is-open');
      if (bar.classList.contains('is-open')) $('input', bar).focus();
    });
  });
  var mnav = $('.mobile-nav');
  $$('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { mnav.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  });
  $$('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () { mnav.classList.remove('is-open'); document.body.style.overflow = ''; });
  });

  /* ---------- Modal de contacto ---------- */
  var modal = $('#contact-modal');
  var lastFocus = null;
  function openModal(topic) {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (topic) {
      var r = $('input[value="' + topic + '"]', modal);
      if (r) r.checked = true;
    }
    setTimeout(function () { var f = $('input[type="text"], input[type="email"]', modal); if (f) f.focus(); }, 250);
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-contact-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (mnav) mnav.classList.remove('is-open');
      openModal(b.getAttribute('data-contact-open'));
    });
  });
  $$('[data-contact-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); if (mnav) { mnav.classList.remove('is-open'); document.body.style.overflow = ''; } }
  });
  // Si Shopify regresó la página con el formulario enviado, abrir el modal para mostrar el resultado
  if (modal && modal.hasAttribute('data-auto-open')) openModal();

  // Copiar correo
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var txt = b.getAttribute('data-copy');
      var done = function () { var o = b.textContent; b.textContent = '¡Copiado!'; setTimeout(function () { b.textContent = o; }, 1600); };
      if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, done); else done();
    });
  });

  // El tema del mensaje se agrega al asunto/cuerpo
  $$('form[data-contact-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var t = $('input[name="contact[Tipo]"]:checked', form);
      var body = $('textarea[name="contact[body]"]', form);
      if (t && body && body.value.indexOf('[') !== 0) body.value = '[' + t.value + '] ' + body.value;
    });
  });

  /* ---------- Reveal al hacer scroll ---------- */
  var revealEls = $$('.reveal, .reveal-stagger');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Contadores ---------- */
  $$('[data-count-to]').forEach(function (el) {
    var target = parseFloat(el.getAttribute('data-count-to')) || 0;
    var run = function () {
      if (reduceMotion) { el.textContent = target.toLocaleString('es-MX'); return; }
      var start = null;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 1800, 1);
        var v = Math.round(target * (1 - Math.pow(1 - p, 4)));
        el.textContent = v.toLocaleString('es-MX');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { run(); o.disconnect(); } });
      o.observe(el);
    } else run();
  });

  /* ---------- Spotlight en tarjetas de categoría ---------- */
  $$('.cat').forEach(function (c) {
    c.addEventListener('pointermove', function (e) {
      var r = c.getBoundingClientRect();
      c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      c.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });

  /* ---------- Cuenta regresiva ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var raw = el.getAttribute('data-countdown');
    var end = raw ? new Date(raw).getTime() : NaN;
    if (isNaN(end) || end < Date.now()) {
      // Sin fecha válida: reinicia cada medianoche para que siempre haya urgencia
      var d = new Date(); d.setHours(23, 59, 59, 999); end = d.getTime();
    }
    var cells = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var diff = Math.max(0, end - Date.now());
      var s = Math.floor(diff / 1000);
      if (cells.d) cells.d.textContent = pad(Math.floor(s / 86400));
      if (cells.h) cells.h.textContent = pad(Math.floor(s % 86400 / 3600));
      if (cells.m) cells.m.textContent = pad(Math.floor(s % 3600 / 60));
      if (cells.s) cells.s.textContent = pad(s % 60);
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Chispas del hero (canvas) ---------- */
  var canvas = $('.hero__sparks');
  if (canvas && canvas.getContext && !reduceMotion) {
    var ctx = canvas.getContext('2d');
    var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var sparks = [];
    var origin = { x: 0, y: 0 };
    var mouse = null;
    var resize = function () {
      var r = canvas.getBoundingClientRect();
      W = r.width; H = r.height;
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var vis = $('.hero__visual');
      if (vis && getComputedStyle(vis).position !== 'absolute') {
        var vr = vis.getBoundingClientRect();
        origin.x = vr.left - r.left + vr.width * 0.5;
        origin.y = vr.top - r.top + vr.height * 0.62;
      } else { origin.x = W * 0.78; origin.y = H * 0.55; }
    };
    resize();
    window.addEventListener('resize', resize);
    canvas.parentElement.addEventListener('pointermove', function (e) {
      var r = canvas.getBoundingClientRect();
      mouse = { x: e.clientX - r.left, y: e.clientY - r.top, t: Date.now() };
    });
    var spawn = function (x, y, n, power) {
      for (var i = 0; i < n; i++) {
        var a = Math.PI * (1.05 + Math.random() * 0.9);
        var sp = (2 + Math.random() * 7) * power;
        sparks.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - Math.random() * 2, life: 1, decay: 0.008 + Math.random() * 0.02, w: 0.6 + Math.random() * 1.6 });
      }
    };
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(canvas);
    }
    var loop = function () {
      requestAnimationFrame(loop);
      if (!visible) return;
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      spawn(origin.x, origin.y, 3, 1);
      if (mouse && Date.now() - mouse.t < 120) spawn(mouse.x, mouse.y, 2, 0.6);
      for (var i = sparks.length - 1; i >= 0; i--) {
        var p = sparks[i];
        var px = p.x, py = p.y;
        p.vy += 0.16; p.vx *= 0.99;
        p.x += p.vx; p.y += p.vy;
        p.life -= p.decay;
        if (p.y > H - 4 && p.vy > 0) { p.vy *= -0.35; p.y = H - 4; }
        if (p.life <= 0) { sparks.splice(i, 1); continue; }
        var g = Math.floor(120 + 135 * p.life);
        ctx.strokeStyle = 'rgba(255,' + g + ',' + Math.floor(40 * p.life) + ',' + p.life + ')';
        ctx.lineWidth = p.w;
        ctx.beginPath(); ctx.moveTo(px - p.vx * 1.5, py - p.vy * 1.5); ctx.lineTo(p.x, p.y); ctx.stroke();
      }
      if (sparks.length > 500) sparks.splice(0, sparks.length - 500);
    };
    loop();
  }

  /* ---------- Carrito AJAX ---------- */
  var toast = $('#toast');
  var toastTimer;
  function showToast(title, sub) {
    if (!toast) return;
    $('[data-toast-title]', toast).textContent = title;
    $('[data-toast-sub]', toast).textContent = sub || '';
    toast.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-show'); }, 3600);
  }
  function setCount(n) {
    $$('.cart-count').forEach(function (c) {
      c.textContent = n; c.setAttribute('data-count', n);
      c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
    });
  }
  function addToCart(id, qty, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('disabled', ''); }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        var item = res.items && res.items[0];
        showToast('¡Agregado al carrito!', item ? item.product_title : '');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function (err) { showToast('No se pudo agregar', (err && (err.description || err.message)) || 'Intenta de nuevo'); })
      .then(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('disabled'); } });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-add');
    if (!id || id === 'demo') { showToast('Producto de muestra', 'Agrega tus productos en Shopify para venderlos'); return; }
    addToCart(id, 1, b);
  });
  $$('form[data-product-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = $('[name="id"]', f).value;
      var q = parseInt(($('[name="quantity"]', f) || {}).value || '1', 10);
      addToCart(id, q, $('[type="submit"]', f));
    });
  });

  /* ---------- Cantidad ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = $('input', b.parentElement);
    var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-qty'), 10);
    input.value = Math.max(parseInt(input.min || '1', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variantes en página de producto ---------- */
  var pjson = $('[data-product-json]');
  if (pjson) {
    var product = JSON.parse(pjson.textContent);
    var form = $('form[data-product-form]');
    var money = function (cents) {
      return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    var update = function () {
      var sel = $$('.option input:checked', form).map(function (i) { return i.value; });
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      var btn = $('[type="submit"]', form);
      if (!v) { btn.setAttribute('disabled', ''); btn.querySelector('span').textContent = 'No disponible'; return; }
      $('[name="id"]', form).value = v.id;
      var now = $('[data-price-now]'); if (now) now.textContent = money(v.price);
      var was = $('[data-price-was]');
      if (was) { was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      if (v.available) { btn.removeAttribute('disabled'); btn.querySelector('span').textContent = 'Agregar al carrito'; }
      else { btn.setAttribute('disabled', ''); btn.querySelector('span').textContent = 'Agotado'; }
      if (v.featured_image) {
        var main = $('.gallery__main img'); if (main) main.src = v.featured_image.src;
      }
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('.option input', form).forEach(function (i) { i.addEventListener('change', update); });
  }
  $$('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = $('.gallery__main img'); if (main) main.src = t.getAttribute('data-thumb');
      $$('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
    });
  });

  /* ---------- Ordenar colección ---------- */
  var sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); location.href = u.toString();
  });

  /* =========================================================
     MÚSICA — si hay un MP3 configurado lo usa; si no, genera
     un beat industrial con Web Audio (sin archivos externos).
     ========================================================= */
  var musicBtn = $('#music');
  if (musicBtn) {
    var src = musicBtn.getAttribute('data-src');
    var vol = parseFloat(musicBtn.getAttribute('data-volume') || '0.5');
    var hint = $('.music__hint', musicBtn);
    var playing = false;
    var audioEl = null;
    var synth = null;
    var KEY = 'torvitan-music';

    function setUI(on) {
      playing = on;
      musicBtn.classList.toggle('is-playing', on);
      musicBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      $('[data-music-state]', musicBtn).textContent = on ? 'Sonando' : 'Pausado';
      $('[data-music-icon-play]', musicBtn).style.display = on ? 'none' : '';
      $('[data-music-icon-pause]', musicBtn).style.display = on ? '' : 'none';
      if (hint) { hint.remove(); hint = null; }
      try { localStorage.setItem(KEY, on ? 'on' : 'off'); } catch (e) {}
    }

    function Synth() {
      var AC = window.AudioContext || window.webkitAudioContext;
      var ac = new AC();
      var master = ac.createGain(); master.gain.value = 0;
      var comp = ac.createDynamicsCompressor();
      comp.threshold.value = -18; comp.ratio.value = 4;
      master.connect(comp); comp.connect(ac.destination);

      // Reverb simple
      var conv = ac.createConvolver();
      var len = ac.sampleRate * 2.4, ir = ac.createBuffer(2, len, ac.sampleRate);
      for (var c = 0; c < 2; c++) { var ch = ir.getChannelData(c); for (var i = 0; i < len; i++) ch[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.6); }
      conv.buffer = ir;
      var wet = ac.createGain(); wet.gain.value = 0.28;
      conv.connect(wet); wet.connect(master);

      var noiseBuf = ac.createBuffer(1, ac.sampleRate, ac.sampleRate);
      var nd = noiseBuf.getChannelData(0); for (var k = 0; k < nd.length; k++) nd[k] = Math.random() * 2 - 1;

      var bpm = 98, step16 = 60 / bpm / 4;
      // Progresión en La menor: Am – F – C – G
      var roots = [45, 41, 48, 43];
      var chords = [[57, 60, 64], [53, 57, 60], [55, 60, 64], [55, 59, 62]];
      var mtof = function (m) { return 440 * Math.pow(2, (m - 69) / 12); };

      function kick(t) {
        var o = ac.createOscillator(), g = ac.createGain();
        o.frequency.setValueAtTime(150, t); o.frequency.exponentialRampToValueAtTime(42, t + 0.14);
        g.gain.setValueAtTime(1, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.42);
        o.connect(g); g.connect(master); o.start(t); o.stop(t + 0.45);
      }
      function noiseHit(t, dur, freq, type, gain, toVerb) {
        var s = ac.createBufferSource(); s.buffer = noiseBuf;
        var f = ac.createBiquadFilter(); f.type = type; f.frequency.value = freq; f.Q.value = 0.8;
        var g = ac.createGain();
        g.gain.setValueAtTime(gain, t); g.gain.exponentialRampToValueAtTime(0.001, t + dur);
        s.connect(f); f.connect(g); g.connect(master); if (toVerb) g.connect(conv);
        s.start(t); s.stop(t + dur + 0.02);
      }
      function snare(t) {
        noiseHit(t, 0.22, 1800, 'bandpass', 0.55, true);
        var o = ac.createOscillator(), g = ac.createGain();
        o.type = 'triangle'; o.frequency.setValueAtTime(220, t); o.frequency.exponentialRampToValueAtTime(140, t + 0.08);
        g.gain.setValueAtTime(0.35, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.12);
        o.connect(g); g.connect(master); o.start(t); o.stop(t + 0.14);
      }
      // "Golpe de metal" — yunque
      function anvil(t) {
        [1, 2.76, 5.4].forEach(function (r, i) {
          var o = ac.createOscillator(), g = ac.createGain();
          o.type = 'sine'; o.frequency.value = 520 * r;
          g.gain.setValueAtTime(0.09 / (i + 1), t); g.gain.exponentialRampToValueAtTime(0.0008, t + 0.9);
          o.connect(g); g.connect(master); g.connect(conv); o.start(t); o.stop(t + 1);
        });
      }
      function bass(t, midi, dur) {
        var o = ac.createOscillator(), f = ac.createBiquadFilter(), g = ac.createGain();
        o.type = 'sawtooth'; o.frequency.value = mtof(midi);
        f.type = 'lowpass'; f.Q.value = 6;
        f.frequency.setValueAtTime(900, t); f.frequency.exponentialRampToValueAtTime(140, t + dur);
        g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(0.32, t + 0.01); g.gain.exponentialRampToValueAtTime(0.001, t + dur);
        o.connect(f); f.connect(g); g.connect(master); o.start(t); o.stop(t + dur + 0.05);
      }
      function pad(t, notes, dur) {
        notes.forEach(function (n) {
          [-6, 6].forEach(function (det) {
            var o = ac.createOscillator(), f = ac.createBiquadFilter(), g = ac.createGain();
            o.type = 'sawtooth'; o.frequency.value = mtof(n); o.detune.value = det;
            f.type = 'lowpass'; f.frequency.value = 1100;
            g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(0.022, t + 0.8); g.gain.linearRampToValueAtTime(0.0001, t + dur);
            o.connect(f); f.connect(g); g.connect(master); g.connect(conv); o.start(t); o.stop(t + dur + 0.1);
          });
        });
      }
      function pluck(t, midi) {
        var o = ac.createOscillator(), f = ac.createBiquadFilter(), g = ac.createGain();
        o.type = 'square'; o.frequency.value = mtof(midi);
        f.type = 'lowpass'; f.frequency.setValueAtTime(3200, t); f.frequency.exponentialRampToValueAtTime(400, t + 0.2);
        g.gain.setValueAtTime(0.06, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.28);
        o.connect(f); f.connect(g); g.connect(master); g.connect(conv); o.start(t); o.stop(t + 0.3);
      }

      var step = 0, nextT = 0, timer = null;
      var bassPat = [1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 1];
      var arp = [0, 1, 2, 1, 2, 0, 1, 2];
      function schedule() {
        while (nextT < ac.currentTime + 0.12) {
          var s = step % 16, bar = Math.floor(step / 16), ci = bar % 4;
          var section = Math.floor(bar / 8) % 2; // alterna intensidad cada 8 compases
          if (s === 0 || s === 8 || (s === 10 && bar % 2)) kick(nextT);
          if (s === 4 || s === 12) snare(nextT);
          if (s % 2 === 0) noiseHit(nextT, s % 4 === 2 ? 0.09 : 0.035, 8000, 'highpass', s % 4 === 2 ? 0.2 : 0.11, false);
          if (bassPat[s]) bass(nextT, roots[ci] - 12 + (s === 13 ? 12 : 0), step16 * 1.8);
          if (s === 0) pad(nextT, chords[ci], step16 * 16);
          if (section === 1 && s % 2 === 1) pluck(nextT, chords[ci][arp[(s >> 1) % 8]] + 12);
          if (s === 15 && bar % 4 === 3) anvil(nextT);
          nextT += step16; step++;
        }
      }
      this.start = function () {
        if (ac.state === 'suspended') ac.resume();
        nextT = ac.currentTime + 0.06;
        timer = setInterval(schedule, 25);
        master.gain.cancelScheduledValues(ac.currentTime);
        master.gain.setValueAtTime(master.gain.value, ac.currentTime);
        master.gain.linearRampToValueAtTime(0.55 * vol, ac.currentTime + 1.2);
      };
      this.stop = function () {
        master.gain.cancelScheduledValues(ac.currentTime);
        master.gain.setValueAtTime(master.gain.value, ac.currentTime);
        master.gain.linearRampToValueAtTime(0, ac.currentTime + 0.4);
        setTimeout(function () { clearInterval(timer); timer = null; }, 450);
      };
    }

    function play() {
      if (src) {
        if (!audioEl) { audioEl = new Audio(src); audioEl.loop = true; audioEl.volume = vol; }
        var p = audioEl.play();
        if (p && p.catch) p.catch(function () { setUI(false); });
      } else {
        if (!synth) synth = new Synth();
        synth.start();
      }
      setUI(true);
    }
    function pause() {
      if (audioEl) audioEl.pause();
      if (synth) synth.stop();
      setUI(false);
    }
    musicBtn.addEventListener('click', function () { playing ? pause() : play(); });

    // Los navegadores no dejan reproducir audio sin interacción: arranca con el primer clic/tecla
    // si el visitante no la apagó antes y el ajuste de autoplay está activo.
    var pref = null; try { pref = localStorage.getItem(KEY); } catch (e) {}
    if (musicBtn.hasAttribute('data-autoplay') && pref !== 'off') {
      var first = function (e) {
        document.removeEventListener('pointerdown', first, true);
        document.removeEventListener('keydown', first, true);
        if (musicBtn.contains(e.target) || playing) return;
        play();
      };
      document.addEventListener('pointerdown', first, true);
      document.addEventListener('keydown', first, true);
    }
  }
})();
